import { layerStyles } from 'map-style'
import { useHighlightIds } from '~map-filter-view/states/filter'

export default function useFilterBorderStyle() {
  const highlightIds = useHighlightIds()
  const filterBorderStyle = layerStyles.getFilterBorderStyle(highlightIds)
  return filterBorderStyle
}
